import { render, staticRenderFns } from "./ResearchShooting.vue?vue&type=template&id=6d372280&scoped=true"
import script from "./ResearchShooting.vue?vue&type=script&lang=js"
export * from "./ResearchShooting.vue?vue&type=script&lang=js"
import style0 from "./ResearchShooting.vue?vue&type=style&index=0&id=6d372280&prod&lang=less&scoped=true"
import style1 from "./ResearchShooting.vue?vue&type=style&index=1&id=6d372280&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d372280",
  null
  
)

export default component.exports